"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Methods = void 0;
/**
 * 服务调用方式
 * enum：POST|GET|DELETE
 */
var Methods;
(function (Methods) {
    Methods["POST"] = "post";
    Methods["GET"] = "get";
    Methods["DELETE"] = "delete";
    Methods["PUT"] = "put";
    Methods["POSTFILE"] = "postFile";
})(Methods = exports.Methods || (exports.Methods = {}));
//# sourceMappingURL=method.js.map